module.exports = __webpack_public_path__ + "static/img/24.a0b60a24.jpg";